<div class="breadcrumb-bar" data-element="breadcrumb-bar" *ngIf="this.hasAny"
     (click)="this.expand.emit()">
  <!-- CR-20260831-004: .changed = a field this chip summarises no longer matches the last run. -->
  <span class="chip" data-element="chip-dates" *ngIf="this.datesChip"
        [class.changed]="this.datesChanged">{{ this.datesChip }}</span>
  <span class="chip" data-element="chip-exclusions" *ngIf="this.exclusionsChip"
        [class.changed]="this.exclusionsChanged">{{ this.exclusionsChip }}</span>
  <span class="chip" data-element="chip-bias" *ngIf="this.biasChip"
        [class.changed]="this.biasChanged">{{ this.biasChip }}</span>
  <span class="edit-hint" data-element="breadcrumb-edit-hint">Click to Edit</span>
</div>
